<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid class="pt-3 pb-3">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Tratramiento</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Descuento_plan</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="subtitulos">Cambiar Descuento a planes</b-col>
      </b-row>
      <b-row>
        <b-col class="text-left">
          <b-form-group label="Tipo de modificación de descuento" v-slot="{ ariaDescribedby }">
            <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" :value="1">
              Tratamiento con descuentos
            </b-form-radio>
            <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" :value="2">
              Referencia de tratamiento
            </b-form-radio>
            <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" :value="3">
              Referencia de módulo
            </b-form-radio>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group align="left">
            <label  for="tratamientos">Tratamientos
              <validacion/>
            </label>
            <v-select id="tratamientos" name="tratamientos" placeholder="Tratamiento"
                      label="nombre"
                      :options="tratamientos"
                      :reduce="(variable) => variable.idTratamiento"
                      v-model="$v.datos.idTratamiento.$model"
                      :class="selectClass('idTratamiento')"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if=" selected === 2">
        <b-col>
          <b-form-group align="left">
            <label  for="tratamientosREf">Tratamiento de referencia
              <validacion/>
            </label>
            <v-select id="tratamientos" name="tratamientosREf" placeholder="Tratamiento"
                      label="nombre"
                      :options="tratamientos"
                      :reduce="(variable) => variable.idTratamiento"
                      v-model="$v.datos.idTratamientoRef.$model"
                      :class="selectClass('idTratamientoRef')"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if=" selected === 3">
        <b-col>
          <b-form-group align="left">
            <label for="modulos">Módulo de referencia
              <validacion/>
            </label>
            <v-select id="modulos" name="modulos" placeholder="Módulo de referencia"
                      label="nombre"
                      :options="modulos"
                      :reduce="(variable) => variable.idModulo"
                      v-model="$v.datos.idModulo.$model"
                      :class="selectClass('idModulo')"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if=" selected === 1">
        <b-col>
          <b-form-group label="Descuentos: %" label-for="decuentotratamiento " align="left">
            <b-form-input
                size="sm"
                id="decuentotratamiento"
                v-model="$v.datos.descuento.$model"
                :state="validateState('descuento')"
                type="number"
                required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Descuento Especial: %"
                        label-for="descuentoespecialtratamiento" align="left">
            <b-form-input
                size="sm"
                id="descuentoespecialtratamiento"
                v-model="$v.datos.descuentoEspecial.$model"
                :state="validateState('descuentoEspecial')"
                type="number"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Número de veces al año: " label-for="numeroveces" align="left">
            <b-form-input
                size="sm"
                id="numeroveces"
                v-model="$v.datos.vecesAnio.$model"
                :state="validateState('vecesAnio')"
                type="number"
                required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="outline-primary" :disabled="loader" @click="guardar()">
            <span v-if="!loader">Guardar</span>
            <span v-if="loader">
                        <b-spinner small></b-spinner>
                    Guardando...
                    </span>
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {required, numeric} from "vuelidate/lib/validators";

export default {
  name: "DescuentoTratamiento",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      selected: 1,
      loader: false,
      tratamientos: [],
      modulos: [],
      datos: {
        idTratamiento: null,
        descuento: null,
        descuentoEspecial: null,
        vecesAnio: null,
        idModulo: null,
        idTratamientoRef: null,
        tipoAccion: 1
      },
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
    }
  },
  validations() {
    if(this.selected === 1){
    return {
      datos: {
        idTratamiento: {required},
        descuento: {required, numeric},
        descuentoEspecial: {numeric},
        vecesAnio: {numeric},
      }
    }
  } else if (this.selected === 2){
      return {
        datos: {
          idTratamiento: {required},
          idTratamientoRef: {required},
        }
      }
    }else if (this.selected === 3){
      return {
        datos: {
          idTratamiento: {required},
          idModulo: {required},
        }
      }
    }
},
created()
{
  this.debug = this.$localStorageService.getDebug();

  this.obtenerTratamientos()
  this.obtenerModulos()
}
,
methods: {
  cambio()
  {
  }
,
  obtenerModulos()
  {

    this.datosTabla = [];
    this.$http.post(this.$api + 'modulo/obtener', this.filtro).then(respuesta => {
          if (respuesta.data.data) {
            this.modulos = respuesta.data.data
          }
        }
    )
  }
,
  obtenerTratamientos()
  {
    this.$http.get(this.$api + 'planConvenio/obtener/tratamientos/categoria').then(
        respuesta => {
          if (respuesta.data.data) {
            this.tratamientos = respuesta.data.data;
          }

        }
    )
  }
,
  guardar()
  {
    this.$v.datos.$touch();
    if (this.$v.datos.$anyError) {
      return;
    }
    if (!this.$v.datos.$invalid) {
      this.$swal.fire({
        icon: "info",
        title: "Aviso",
        text: '¿Está seguro de cambiar el descuento para todos los planes activos? \n Esta acción no es reversible',
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then(respuesta => {
        if (respuesta.value) {
          this.loader = true;
          this.datos.tipoAccion = this.selected;
          this.$http.post(this.$api + 'planConvenio/guardar/descuento-por-tratamiento', this.datos).then(
              respuesta => {
                if (respuesta.data.data) {
                  this.$swal({
                    icon: "success",
                    text: "Se actualizaron los descuentos correctamente",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#0e6ba9",
                  });
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "Error",
                    text: 'Error al actualizar el descuento',
                  });
                }

              }
          ).catch(reason => {
            console.error(reason)
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: 'Error al actualizar el descuento',
            });
          }).finally(() => {
            this.loader = false;
          })
        }
      })
    }
  }
,
  validateState(name)
  {
    const {$dirty, $error} = this.$v.datos[name];
    return $dirty ? !$error : null;
  }
,
  selectClass(attribute)
  {
    let state = this.validateState(attribute)
    if (state) {
      return 'border rounded-lg border-success'
    } else if (state === false) {
      return 'border rounded-lg border-danger'
    } else {
      return ''
    }
  }

}
}
</script>

<style scoped>

</style>